import { render, staticRenderFns } from "./GoodTable.vue?vue&type=template&id=54b32fea&scoped=true&"
import script from "./GoodTable.vue?vue&type=script&lang=ts&"
export * from "./GoodTable.vue?vue&type=script&lang=ts&"
import style0 from "./GoodTable.vue?vue&type=style&index=0&id=54b32fea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b32fea",
  null
  
)

export default component.exports